import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '../redux/userSlice'
import notification from '../components/Notification/notification'
import { changePassword } from '../api/passwordApi'
import { passwordActions, passwordSelectors } from '../redux/passwordSlice'

const usePasswordForm = () => {
    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    const isFetching = useSelector(passwordSelectors.isFetching)
    const hasError = useSelector(passwordSelectors.hasError)
    const success = useSelector(passwordSelectors.success)
    const errorMessage = useSelector(passwordSelectors.errorMessage)

    useEffect(() => {
        if (!isFetching) {
            notification.destroy()
            if (success) {
                notification.success({
                    title: 'Success',
                    description: 'Password changed successfully',
                })
            } else if (hasError) {
                notification.failure({
                    title: 'Error',
                    description: errorMessage,
                })
            }
            dispatch(passwordActions.resetState())
        }
    }, [isFetching])

    return async values => {
        notification.loading({
            title: 'Submitting...',
        })
        dispatch(changePassword({ ...values, email: user.email }))
    }
}

export default usePasswordForm
